export default "__VITE_ASSET__k9AQZ6l0__"